import { render, staticRenderFns } from "./prescriptionManager.vue?vue&type=template&id=19d0ea8f&"
import script from "./prescriptionManager.vue?vue&type=script&lang=js&"
export * from "./prescriptionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports